<template>
    <div id="home">        
        <section class="h_security_banner_area" id="Top">
            <img class="p_absoulte s_shap" src="@/assets/img/home-security/shap.png" alt="">
            <div class="s_round one"></div>
            <div class="s_round two"></div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 d-flex align-items-center">
                        <div class="security_banner_content geo_font">
                            <h2 class="wow fadeInUp " data-wow-delay="0.3s">{{ Lang('Shortcut to success for your Wellness business') }}</h2>
                            <p class="f_400 w_color l_height28 wow fadeInUp" data-wow-delay="0.4s">{{ Lang('Sign up now and use it FREE FOREVER !') }}</p>
                            <p class="f_400 w_color l_height28 wow fadeInUp" data-wow-delay="0.4s">{{ Lang('It takes only 2 minitues') }}</p>
                            <div class="action_btn d-flex align-items-center mt_40 wow fadeInUp geo_font" data-wow-delay="0.6s">
                                <button ref="CreatePreOrderForm" data-toggle="modal" data-target="#exampleModalLong" style="display: none;"></button>
                                <a href="javascript:void(0)" v-on:click="OpenPreOrder" class="@/assets/btn_hover app_btn">{{ Lang('Free Sign-Up') }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 wow fadeInRight" data-wow-delay="0.4s">
                        <div class="new_startup_img">
                            <img src="@/assets/img/Fertimo/Fertimo_Page.gif" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="saas_features_area_two geo_font" id="WhyFertimo">
            <div class="container">
                <div class="sec_title text-center mb_70 wow fadeInUp" data-wow-delay="0.3s">
                    <h2 class="f_p f_size_30 l_height50 f_600 t_color geo_font">{{ Lang('Why should you succeed with us ?') }}</h2>
                    <p class="f_400 f_size_16">{{ Lang('We have been in the wellness and ERP solutions development business for over 10 years') }}
                    </p>
                </div>
                <div class="row mb_30">
                    <div class="col-lg-4 col-sm-6">
                        <div class="saas_features_item text-center wow fadeInUp" data-wow-delay="0.3s">
                            <img class="img_height_200" src="@/assets/img/Fertimo/easy.png" alt="">
                            <h4 class="f_size_20 f_p t_color f_500 geo_font">{{ Lang('Effortless') }}</h4>
                            <p class="f_400 f_size_15 mb-0">{{ Lang('Work from any device with web browser, Use our plug&play devices, manage everyday routine the easiest possible way and do not bother with IT stuff, we have you covered') }}</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="saas_features_item text-center wow fadeInUp" data-wow-delay="0.5s">
                            <img class="img_height_200" src="@/assets/img/Fertimo/bi.png" alt="">
                            <h4 class="f_size_20 f_p t_color f_500 geo_font">{{ Lang('Bespoke BI') }}</h4>
                            <p class="f_400 f_size_15 mb-0">{{ Lang('We are to help you build a solid business. Using special tools we have created for you, our partners increase customer retention by 5% and profitability by 14.2%') }}</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="saas_features_item text-center wow fadeInUp" data-wow-delay="0.7s">
                            <img class="img_height_200" src="@/assets/img/Fertimo/tailored.png" alt="">
                            <h4 class="f_size_20 f_p t_color f_500 geo_font">{{ Lang('Tailored to wellness') }}</h4>
                            <p class="f_400 f_size_15 mb-0">{{ Lang('We work close with our partners to find most appropriate solutions to succeed in the business. Our team has developed best practices to approach every buisiness opportunity') }}</p>
                        </div>
                    </div>
                </div>
                <div class="mt_100 mb-0"></div>
            </div>
        </section>

        <section class="saas_service_area sec_pad bg_color_b geo_font" id="HowItWorks">
            <div class="container">
                <div class="sec_title text-center mb_70 wow fadeInUp" data-wow-delay="0.3s">
                    <h2 class="f_p f_size_30 l_height50 f_600 t_color geo_font">{{ Lang('Works out of the box') }}</h2>
                    <p class="f_400 f_size_16">{{ Lang('Fertimo is here to help you achieve maximum results with minimum effort. ') }}<br>{{ Lang('Concentrate on important things, ones you do the best. We will take care of the rest') }}</p>
                </div>
                <div class="row saas_service_item">
                    <div class="col-lg-6">
                        <div class="saas_service_img wow fadeInLeft" data-wow-delay="0.5s">
                            <img src="@/assets/img/Fertimo/Pos_472.gif" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6 d-flex align-items-center">
                        <div class="saas_service_content pr_100 wow fadeInRight" data-wow-delay="0.7s">
                            <h4 class="f_500 f_p t_color geo_font">{{ Lang('Your Business in your pocket') }}</h4>
                            <p class="f_p f_400 geo_font">{{ Lang('2 minutes to register, 10 minutes to set up and you are ready to serve your clients. Our knowledge base will guide you to the best practice approaches, if you still need assitance our tem is happy to help out. You will be able to set and achieve goals, increase business performance, control processes from anywhere') }}</p>
                            <a href="#" class="gr_btn"><span class="text geo_font">{{ Lang('Learn More') }}</span></a>
                        </div>
                    </div>
                </div>
                <div class="row flex-row-reverse saas_service_item">
                    <div class="col-lg-6">
                        <div class="saas_service_img wow fadeInRight" data-wow-delay="0.4s">
                            <img src="@/assets/img/Fertimo/User_472.gif" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6 d-flex align-items-center">
                        <div class="saas_service_content pl_100 wow fadeInLeft" data-wow-delay="0.6s">
                            <h4 class="f_500 f_p t_color geo_font">{{ Lang('Grow Your Business') }}</h4>
                            <p class="f_p f_400 geo_font">{{ Lang('Our mission is to bring you all the benefits of advanced ERP systems within a click. Fertimo will help your business achieve high customer loyalty and retention rates, increase profitability by giving you tips, industry analysis and proper targets to focus on') }}</p>
                            <a href="#" class="gr_btn geo_font"><span class="text">{{ Lang('Learn More') }}</span></a>
                        </div>
                    </div>
                </div>
                <div class="row saas_service_item">
                    <div class="col-lg-6">
                        <div class="saas_service_img wow fadeInLeft" data-wow-delay="0.5s">
                            <img src="@/assets/img/Fertimo/Service_472.gif" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6 d-flex align-items-center geo_font">
                        <div class="saas_service_content pr_100 wow fadeInRight" data-wow-delay="0.7s">
                            <h4 class="f_500 f_p t_color geo_font">{{ Lang('Everything is Included') }}</h4>
                            <p class="f_p f_400 geo_font">{{ Lang('We avoid using other system services and cross integrations, you dont have to boother how back-ups, email services and analytics work. All we want is to give businesses more time to focus on thing they do the best. In Fertimo you can manage everything from a single browser window, this will save your time, money and nerves') }}</p>
                            <a href="#" class="gr_btn geo_font"><span class="text geo_font">{{ Lang('Learn More') }}</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="hosting_service_area sec_pad geo_font" id="Modules">
            <div data-parallax='{"x": 0, "y": 100}'><div class="pattern_shap" style="background: url(@/assets/img/pos/pattern_02.png);"></div></div>
            <div class="container">
                <div class="sec_title text-center mb_70 wow fadeInUp" data-wow-delay="0.3s">
                    <h2 class="wow fadeInUp" data-wow-delay="0.3s">{{ Lang('Every module you thought of') }}<br>{{ Lang('Is already included') }}</h2>
                </div>
                <div class="row pos_service_info">
                    <div class="col-lg-4 col-sm-6">
                        <div class="hosting_service_item">
                            <img class="module_logo_img" src="@/assets/img/pos/laptop.png" alt="">
                            <a href="#"><h4 class="h_head geo_font">{{ Lang('Operations') }}</h4></a>
                            <p>{{ Lang('Manage facility, access, services, cotracts, registration, products, sales, staff and more') }}<br>  </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="hosting_service_item">
                            <img class="module_logo_img" src="@/assets/img/pos/statistics.png" alt="">
                            <a href="#"><h4 class="h_head">{{ Lang('Analytics') }}</h4></a>
                            <p>{{ Lang('We measure and show important metrics: customer loyalty, retention rates, and business efficiency') }}</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div  class="hosting_service_item">
                            <img class="module_logo_img" src="@/assets/img/pos/delivery-truck.png" alt="">
                            <a href="#"><h4 class="h_head">{{ Lang('Warehouse') }}</h4></a>
                            <p>{{ Lang('Manage products, categories, several warehouses and even portions and batches') }}</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="hosting_service_item">
                            <img class="module_logo_img" src="@/assets/img/pos/cash-register.png" alt="">
                            <a href="#"><h4 class="h_head">{{ Lang('HR') }}</h4></a>
                            <p>{{ Lang('Access permissions, perfomrance, work schedule, timeline, salary and bonuses') }}</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="hosting_service_item">
                            <div class="icon">
                                <img class="module_logo_img" src="@/assets/img/pos/credit-card.png" alt="">
                            </div>
                            <a href="#"><h4 class="h_head">{{ Lang('Finance') }}</h4></a>
                            <p>{{ Lang('Monitor and manage Sales, profitability ratios, insights, lots of different reports') }}</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                        <div class="hosting_service_item">
                            <div class="icon">
                                <img class="module_logo_img" src="@/assets/img/pos/mailbox.png" alt="">
                            </div>
                            <a href="#"><h4 class="h_head">{{ Lang('Scheduling') }}</h4></a>
                            <p>{{ Lang('Schedule customer visits, events, classes, performers and assets, account for inventory usage') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="erp_analytics_area text_color_w geo_font">
            <img class="p_absoulte s_shap" src="@/assets/img/home-security/shap.png" alt="" >
            <div class="s_round"></div>
            <div class="s_round"></div>
                <div class="container">
                <div class="row">
                    <div class="col-md-4 ">
                        <div class="erp_analytics_item text-center">
                            <img src="@/assets/img/Fertimo/users.png" alt="">
                            <div class = "text_size_50"> 
                                <p v-if="Stats && Stats.users">{{ NumFormatter(Stats.users) }}</p> 
                            </div>
                            <p> {{ Lang('Users') }}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="erp_analytics_item text-center">
                            <img src="@/assets/img/Fertimo/visits2.png" alt="">
                            <p v-if="Stats && Stats.user_visits"> {{ NumFormatter(Stats.user_visits) }}</p>
                            <p> {{ Lang('Visits') }}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="erp_analytics_item text-center">
                            <img src="@/assets/img/Fertimo/company.png" alt="">
                            <p v-if="Stats && Stats.companies">{{ NumFormatter(Stats.companies) }}</p>
                            <p> {{ Lang('Companies') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="saas_features_area_two geo_font">
            <div class="container">
                <div class="sec_title text-center mb_70 wow fadeInUp" data-wow-delay="0.3s">
                    <h2 class="f_p f_size_30 l_height50 f_600 t_color geo_font">{{ Lang('Our plug&play devices ready to go') }}</h2>
                    <p class="f_400 f_size_16">{{ Lang('Just connect to the ethenrent of WiFi and they will work out of the box with our software') }}</p>
                    <p class="f_400 f_size_16">{{ Lang('You wont need expert installation or support, drivers and etc. They come with lot of features you will love') }}
                    </p>
                </div>
                <div class="row geo_font">
                    <div class="col-lg-4 col-sm-4">
                        <div class="single_product_item">
                            <div class="product_img">
                                <img class="img-fluid" src="@/assets/img/Fertimo/Reader.png" alt="">
                                <div class="hover_content">
                                    <a href="#"><i class="ti-heart"></i></a>
                                    <a href="#" title="Add to cart"><i class="ti-bag"></i></a>
                                    <a href="#"><i class="ti-eye"></i></a>
                                </div>
                            </div>
                            <div class="single_pr_details">
                                <a href="#">
                                    <h3 class="f_p f_500 f_size_16 geo_font">{{ Lang('RFID Reader') }}</h3>
                                </a>
                                <div class="price">
                                    <ins><span class="woocommerce-Price-amount amount geo_font"><span class="woocommerce-Price-currencySymbol geo_font"></span>{{ Lang('FREE') }}</span></ins>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-4">
                        <div class="single_product_item">
                            <div class="product_img">
                                <img class="img-fluid" src="@/assets/img/Fertimo/RFID_Controller.png" alt="">
                                <div class="hover_content">
                                    <a href="#"><i class="ti-heart"></i></a>
                                    <a href="#" title="Add to cart"><i class="ti-bag"></i></a>
                                    <a href="#"><i class="ti-eye"></i></a>
                                </div>
                            </div>
                            <div class="single_pr_details">
                                <a href="#">
                                    <h3 class="f_p f_500 f_size_16 geo_font">{{ Lang('Door / Turnstile Controller') }}</h3>
                                </a>
                                <div class="price">
                                    <ins><span class="woocommerce-Price-amount amount geo_font"><span class="woocommerce-Price-currencySymbol geo_font"></span>700 GEL (250USD)</span></ins>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-4">
                        <div class="single_product_item">
                            <div class="product_img">
                                <img class="img-fluid" src="@/assets/img/Fertimo/Smart_Locker.png" alt="">
                                <div class="hover_content">
                                    <a href="#"><i class="ti-heart"></i></a>
                                    <a href="#" title="Add to cart"><i class="ti-bag"></i></a>
                                    <a href="#"><i class="ti-eye"></i></a>
                                </div>
                            </div>
                            <div class="single_pr_details">
                                <a href="#">
                                    <h3 class="f_p f_500 f_size_16 geo_font">{{ Lang('Smart Locker System') }}</h3>
                                </a>
                                <div class="price">
                                    <ins><span class="woocommerce-Price-amount amount geo_font"><span class="woocommerce-Price-currencySymbol"></span>100 GEL (35 USD)</span></ins>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="analytices_price_area pt_70 bg_color_b geo_font" id="Pricing">
            <div class="container">
                <div class="sec_title text-center mb_70 wow fadeInUp" data-wow-delay="0.3s">
                    <h2>{{ Lang('Tailored to any size business') }}</h2>
                    <h2>{{ Lang('Starts and continues Free Forever !') }}</h2>
                </div>
                <div class="row align-items-center">
                    <div class="col-lg-4 col-md-6">
                        <div class="analytices_price_item">
                            <div class="p_head">
                                <h5>{{ Lang('FREE') }}</h5>
                                <div class="rate">{{ Lang('$0 USD') }}</div>
                                <h6>{{ Lang('per month') }}</h6>
                            </div>
                            <ul class="list-unstyled p_body">
                                <li>{{ Lang('Unlimited Employees') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited Services') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited Schedules') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited User-Clients') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Single System User') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('10 products in warehouse') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Essential Reports') }} <i class="ti-check"></i></li>
                                <a href="javascript:void(0)" v-on:click="OpenPreOrder" class="er_btn er_btn_two er_btn_two_w geo_font">{{ Lang('Start for Free Now !') }}</a>
                            </ul>
                        </div>
                    </div>
                    <!--
                    <div class="col-lg-4 col-md-6">
                        <div class="analytices_price_item">
                            <div class="p_head">
                                <h5>{{ Lang('Special Package') }}</h5>
                                <h6 class="tag"><i class="icon_ribbon_alt"></i>Only one of these</h6>
                                <div class="rate">33 {{ Lang('$') }}</div>
                                <h6>{{ Lang('per month') }}</h6>
                            </div>
                            <ul class="list-unstyled p_body">
                                <li>{{ Lang('+ Unlimited System Users') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('+ Network Business (Per Location)') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('+ 500 Products in warehouse') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('+ Advanced Reports & Analytics') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('+ Facility Access Hardware') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('+ CRM Tools') }} <i class="ti-check"></i></li>
                            </ul>
                        </div>
                    </div>
                    -->
                    <div class="col-lg-4 col-md-6">
                        <div class="analytices_price_item active">
                            <div class="p_head">
                                <h5>{{ Lang('Premium') }}</h5>
                                <div class="rate">{{ Lang('$179 USD') }}</div>
                                <h6>{{ Lang('439 GEL') }}</h6>
                                <h6>{{ Lang('per month') }}</h6>
                            </div>
                            <ul class="list-unstyled p_body">
                                <li>{{ Lang('Unlimited Employees') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited Services') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited Schedules') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited User-Clients') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited System User') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('500 products in warehouse') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Advanced Reports & Analytics') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Facility Access Hardware') }} <i class="ti-check"></i></li>
                                <a href="javascript:void(0)" v-on:click="OpenPreOrder" class="er_btn er_btn_two geo_font">{{ Lang('Start for Free Now !') }}</a>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="analytices_price_item">
                            <div class="p_head">
                                <h5>{{ Lang('Network Business') }}</h5>
                                <h6 class="tag"><i class="icon_ribbon_alt"></i>{{ Lang('Several Locations') }}</h6>
                                <div class="rate">{{ Lang('$239 USD') }}</div>
                                <h6>{{ Lang('579 GEL') }}</h6>
                                <h6>{{ Lang('per month') }}</h6>
                            </div>
                            <ul class="list-unstyled p_body">
                                <li>{{ Lang('Unlimited Employees') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited Services') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited Schedules') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited User-Clients') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Unlimited System Users') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('500 products in warehouse') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Advanced Reports & Analytics') }} <i class="ti-check"></i></li>
                                <li>{{ Lang('Facility Access Hardware') }} <i class="ti-check"></i></li>
                                <a href="javascript:void(0)" v-on:click="OpenPreOrder" class="er_btn er_btn_two er_btn_two_w geo_font">{{ Lang('Start for Free Now !') }}</a>
                            </ul>
                        </div>
                    </div>

                <div class="container">
                    <div class="sec_title text-center mb_70 wow fadeInUp mt_60 geo_font" data-wow-delay="0.3s">
                        <h2 class="f_p f_size_30 l_height50 f_600 t_color geo_font">{{ Lang('Flexible Plans') }}</h2>
                        <p class="f_400 f_size_16 geo_font">{{ Lang('For just ') }}{{ Lang('$33 USD') }}{{ Lang(' you can add one of these features') }}<br>{{ Lang('Unlimited system users; 500 Products in the warehouse; Advanced Reports & analytics;') }}
                        <br>{{ Lang('Facility Access Hardware; Special CRM Tools;') }}</p>
                    </div>
                </div>

                </div>
            </div>
        </section>

        <section class="security_integration_area geo_font" id="Businesses">
            <div class="container geo_font">
                <div class="hosting_title analytices_title text-center geo_font">
                    <h2 class="wow fadeInUp geo_font"><span>{{ Lang('Best For ') }}</span>{{ Lang('The Following Wellness Businesses') }}</h2>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/gym.png" alt="">
                            <h5>{{ Lang('Gym') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/excercise.png" alt="">
                            <h5>{{ Lang('Boutique Fitness') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/judo.png" alt="">
                            <h5>{{ Lang('Martial Arts') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/dress.png" alt="">
                            <h5>{{ Lang('Dance Studios') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/bicycle.png" alt="">
                            <h5>{{ Lang('Outdoor Activities') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/avatar.png" alt="">
                            <h5>{{ Lang('Fitness Trainers') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/dryer.png" alt="">
                            <h5>{{ Lang('Beauty Salons') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/sauna.png" alt="">
                            <h5>{{ Lang('Spas') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/barbershop.png" alt="">
                            <h5>{{ Lang('Hairdressers') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/golf.png" alt="">
                            <h5>{{ Lang('Sports Clubs') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item">
                            <img class="logo_img" src="@/assets/img/Fertimo/pool.png" alt="">
                            <h5>{{ Lang('Swimming Pools') }}</h5>
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <a href="#" class="s_integration_item ">
                            <img class="logo_img" src="@/assets/img/Fertimo/teeth.png" alt="">
                            <h5>{{ Lang('Dental Clinics') }}</h5>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section class="security_action_area geo_font">
            <img class="p_absoulte img_bg" src="img/home-security/sheld_bg.png" alt="">
            <div class="container">
                <div class="security_action_inner">
                    <div class="media">
                        <img src="img/home-security/shield.png" alt="">
                        <div class="media-body">
                            <h3 class="f_600 f_size_30 l_height30 t_color3 mb_50">{{ Lang('No words can explain how good it is, so try yourself :') }}</h3>
                        </div>
                    </div>
                    <a href="javascript:void(0)" v-on:click="OpenPreOrder" class="er_btn er_btn_two text-center geo_font">{{ Lang('register & use for FREE') }}</a>
                </div>
            </div>
        </section>

        <footer class="footer_area h_footer_dark pos_footer_area security_footer_area geo_font" style="margin-top: 50px;">
            <img class="leaf_left" src="img/pos/leaf-left.png" alt="">
            <img class="leaf_right" src="img/pos/leaf-right.png" alt="">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-6">
                        <div class="f_widget dark_widget company_widget">
                            <a href="index.html" class="f-logo"><img src="img/logo2.png" alt=""></a>
                            <p>{{ Lang('© 2020 Wellness Corporation, LLC') }}</p>
                            <ul class="list-unstyled f_list geo_font">
                                <li><a class="geo_font" href="malto:contact@fertimo.com">contact@fertimo.com</a></li>
                                <li><a class="geo_font" href="https://maps.app.goo.gl/21oWiejm48ubD2Gm8">{{ locale("7 Innovations Str. Tbilisi, Georgia") }}</a></li>
                            </ul>
                            <div class="f_social_icon">
                                <a href="https://www.facebook.com/Fertimo-111456580554500/" target="_blank" class="ti-facebook"></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="f_widget dark_widget about-widget pl_20 geo_font">
                            <h3 class="f-title f_500 t_color f_size_18 mb_40">{{ Lang('Useful Links') }}</h3>
                            <ul class="list-unstyled f_list geo_font">
                                <li><a class="geo_font" href="#">{{ Lang('Company') }}</a></li>
                                <li><a class="geo_font" href="#">{{ Lang('Partners') }}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 geo_font">
                        <div class="f_widget dark_widget about-widget pl_20 geo_font">
                            <h3 class="f-title f_500 t_color f_size_18 mb_40 ">{{ Lang('Help') }}</h3>
                            <ul class="list-unstyled f_list geo_font">
                                <li><a class="geo_font" href="#">{{ Lang('FAQ') }}</a></li>
                                <li><router-link class="geo_font" v-bind:to="'terms'">{{ Lang('Term & conditions') }}</router-link></li>
                                <li><a class="geo_font" href="#">{{ Lang('Pricing') }}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6">
                        <div class="f_widget dark_widget about-widget pl_20">
                            <h3 class="f-title f_500 t_color f_size_18 mb_40">{{ Lang('Contact') }}</h3>
                            <ul class="list-unstyled f_list">
                                <li><router-link class="geo_font" v-bind:to="'contact'">{{ Lang('Contact') }}</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="pos_footer_bottom justify-content-between d-flex align-items-end">
                    <img class="pos_women" src="img/pos/women.png" alt="">
                    <img src="img/pos/people.png" alt="">
                    <img class="pos_women" src="img/pos/man.png" alt="">
                </div>
            </div>
            <svg class="wave_shap" xmlns="https://www.w3.org/2000/svg">
                <path fill-rule="evenodd" opacity="0.302" fill="rgb(73, 69, 140)" d="M22.990,11.999 C22.990,11.999 -62.334,196.188 102.000,90.998 C236.033,5.204 349.217,18.152 512.000,80.998 C773.380,181.909 898.075,49.752 1051.000,15.998 C1316.369,-42.574 1488.518,78.268 1581.000,112.999 C1783.485,189.036 1942.990,61.999 1942.990,61.999 L1942.990,211.999 L22.990,211.999 L22.990,11.999 Z" />
            </svg>
        </footer>

        <!-- Modal -->
        <div class="modal fade full-modal" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <!-- <h5 class="modal-title geo_font" id="exampleModalLongTitle">{{ Lang('Register') }}</h5> -->
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fas fa-times" style="font-size: 25px;"></i>
                        </button>
                    </div>
                    <div class="modal-body pb-4">
                        <div class="row" v-if="Object.entries(FormData).length > 0">
                            <div class="col-md-4"></div>
                            <!-- Form content -->
                            <div class="col-sm-4" v-if="ModalUpdate">
                                <h4 class="text-center mb-1 geo_font">Fertimo {{ Lang('Register') }}</h4>
                                <p class="text-center mb-4 geo_font" v-html="Lang('RegisterMessage')"></p>
                                <!-- Personal information -->
                                <div title="Personal information" v-show="ActiveTabs == 'PersonalInformation'">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group geo_font">
                                                <label for="FirstName">{{ Lang('FirstName') }}</label>
                                                <input v-model="FormData.FirstName" v-bind:class="ErrorKey['FirstName'] != undefined ? ErrorKey['FirstName'].class : ''" v-on:keyup="ValidateInput('FirstName')" type="text" id="FirstName" v-bind:placeholder="Lang('Jack') + '...'" class="form-control main-input geo_font">
                                                <div class="invalid-feedback" v-if="ErrorKey['FirstName'] != undefined && ErrorKey['FirstName'].message != undefined">
                                                    <span class="error">{{ ErrorKey['FirstName'].message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group geo_font">
                                                <label for="SurName">{{ Lang('SurName') }}</label>
                                                <input v-model="FormData.SurName" v-bind:class="ErrorKey['SurName']  != undefined ? ErrorKey['SurName'].class : ''" v-on:keyup="ValidateInput('SurName')" type="text" id="SurName" v-bind:placeholder="Lang('Sparrow') + '...'" class="form-control main-input geo_font">
                                                <div class="invalid-feedback" v-if="ErrorKey['SurName'] != undefined && ErrorKey['SurName'].message != undefined">
                                                    <span class="error">{{ ErrorKey['SurName'].message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group geo_font">
                                        <label for="Email">{{ Lang('Email') }}</label>
                                        <input v-model="FormData.Email" v-bind:class="ErrorKey['Email'] != undefined ? ErrorKey['Email'].class : ''" type="text" id="Email" v-bind:placeholder="Lang('jack.sparrow@pirates.com') + '...'" class="form-control main-input geo_font" v-on:keyup="ValidateInput('Email')">
                                        <div class="invalid-feedback" v-if="ErrorKey['Email'] != undefined && ErrorKey['Email'].message != undefined">
                                            <span class="error">{{ ErrorKey['Email'].message }}</span>
                                        </div>
                                    </div>

                                    <div class="form-group geo_font">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label for="password">{{ Lang('Password') }}</label>
                                                <input v-model="FormData.Password" type="password" id="password" v-bind:placeholder="Lang('***')" class="form-control main-input geo_font" v-bind:class="ErrorKey['Password'] != undefined ? ErrorKey['Password'].class : ''" v-on:keyup="ValidateInput('Password')">
                                                <div class="invalid-feedback" v-if="ErrorKey['Password'] != undefined && ErrorKey['Password'].message != undefined">
                                                    <span class="error">{{ ErrorKey['Password'].message }}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <label for="confpassword">{{ Lang('Confirm password') }}</label>
                                                <input  v-model="FormData.ConfPassword" type="password" id="confpassword" 
                                                        v-bind:placeholder="Lang('***')" class="form-control main-input geo_font" 
                                                        v-bind:class="ErrorKey['ConfPassword'] != undefined ? ErrorKey['ConfPassword'].class : ''"  
                                                        v-on:keyup="ValidateInput('ConfPassword')">
                                                <div class="invalid-feedback" v-if="ErrorKey['ConfPassword'] != undefined && ErrorKey['ConfPassword'].message != undefined">
                                                    <span class="error">{{ ErrorKey['ConfPassword'].message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- [./ End] Personal information -->
                                
                                <!-- Location information -->
                                <div title="Location"  v-show="ActiveTabs == 'Location'">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group geo_font">                                            
                                                <label for="Country">{{ Lang('Country') }}</label>
                                                <select v-model="FormData.Country" id="Country" class="form-control main-input geo_font" v-bind:class="ErrorKey['Country'] != undefined ? ErrorKey['Country'].class : ''" v-on:change="ValidateInput('Country')">
                                                    <template v-for="Country in $store.state.Cache.Countries">
                                                        <option v-bind:value="Country">{{ Country }}</option>
                                                    </template>
                                                </select>
                                                <div class="invalid-feedback" v-if="ErrorKey['Country'] != undefined && ErrorKey['Country'].message != undefined">
                                                    <span class="error">{{ ErrorKey['Country'].message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group geo_font">
                                                <label for="City">{{ Lang('City') }}</label>
                                                <input v-model="FormData.City" type="text" id="City" v-bind:placeholder="Lang('City') + '...'" class="form-control main-input geo_font" v-bind:class="ErrorKey['City'] != undefined ? ErrorKey['City'].class : ''" v-on:keyup="ValidateInput('City')">
                                                <div class="invalid-feedback" v-if="ErrorKey['City'] != undefined && ErrorKey['City'].message != undefined">
                                                    <span class="error">{{ ErrorKey['City'].message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group geo_font">
                                                <label for="PhoneIndex">{{ Lang('Phone Index') }}</label>
                                                <input v-model="FormData.PhoneIndex" type="text" id="PhoneIndex" v-bind:placeholder="Lang('Phone Index') + '...'" class="form-control main-input geo_font" v-bind:class="ErrorKey['PhoneIndex'] != undefined ? ErrorKey['PhoneIndex'].class : ''" v-on:keyup="ValidateInput('PhoneIndex')">
                                                <div class="invalid-feedback" v-if="ErrorKey['PhoneIndex'] != undefined && ErrorKey['PhoneIndex'].message != undefined">
                                                    <span class="error">{{ ErrorKey['PhoneIndex'].message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group geo_font">
                                                <label for="Phone">{{ Lang('Phone') }}</label>
                                                <input v-model="FormData.Phone" type="text" id="Phone" v-bind:placeholder="Lang('Phone') + '...'" class="form-control main-input geo_font" v-bind:class="ErrorKey['Phone'] != undefined ? ErrorKey['Phone'].class : ''" v-on:keyup="ValidateInput('Phone')">
                                                <div class="invalid-feedback" v-if="ErrorKey['Phone'] != undefined && ErrorKey['Phone'].message != undefined">
                                                    <span class="error">{{ ErrorKey['Phone'].message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- [./ End] Location information -->

                                <!-- BusinessInformation information -->
                                <div title="Business information"  v-show="ActiveTabs == 'BusinessInformation'">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group geo_font">
                                                <label for="CompanyName">{{ Lang('Company Name') }}</label>
                                                <input v-model="FormData.CompanyName" type="text" id="CompanyName" v-bind:placeholder="Lang('Pearl') + '...'" class="form-control main-input geo_font" v-bind:class="ErrorKey['CompanyName'] != undefined ? ErrorKey['CompanyName'].class : ''" v-on:keyup="ValidateInput('CompanyName')">
                                                <div class="invalid-feedback" v-if="ErrorKey['CompanyName'] != undefined && ErrorKey['CompanyName'].message != undefined">
                                                    <span class="error">{{ ErrorKey['CompanyName'].message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group geo_font">
                                                <label for="RegistrationID">{{ Lang('Registration ID') }}</label>
                                                <input v-model="FormData.RegistrationID" type="text" id="RegistrationID" v-bind:placeholder="Lang('11 ნიშნა') + '...'" class="form-control main-input geo_font" v-bind:class="ErrorKey['RegistrationID'] != undefined ? ErrorKey['RegistrationID'].class : ''" v-on:keyup="ValidateInput('RegistrationID')">
                                                <div class="invalid-feedback" v-if="ErrorKey['RegistrationID'] != undefined && ErrorKey['RegistrationID'].message != undefined">
                                                    <span class="error">{{ ErrorKey['RegistrationID'].message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- [./ End] BusinessInformation information -->

                                <!-- BusinessAreas information -->
                                <div title="Business areas"  v-show="ActiveTabs == 'BusinessAreas'">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group geo_font">
                                                <label for="BusinessAreas">{{ Lang('Business Areas') }}</label>
                                                <div class="form-group">
                                                    <template v-for="item in $store.state.Cache.BusinessAreas">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="FormData.BusinessAreas" type="checkbox" v-bind:value="item.id" class="custom-control-input" v-bind:id="item.id" v-on:change="ValidateInput('BusinessAreas')" v-bind:disabled="OtherBusinessAreas">
                                                            <label class="custom-control-label geo_font" v-bind:for="item.id">{{ item.Name }}</label>
                                                        </div>
                                                    </template>
                                                </div>

                                                <!-- Other bussiness area -->
                                                <div class="custom-control custom-checkbox">
                                                    <input v-model="OtherBusinessAreas" type="checkbox" class="custom-control-input" id="OtherBusinessAreas" v-bind:disabled="FormData.BusinessAreas.length > 0">
                                                    <label class="custom-control-label geo_font" for="OtherBusinessAreas">{{ Lang('Other') }}</label>
                                                </div>
                                                <div class="form-group" v-if="OtherBusinessAreas">
                                                    <input type="text" v-model="FormData.BusinessAreaOther" class="form-control" v-bind:placeholder="Lang('Enter other area') + '...'" v-on:keyup="ValidateInput('BusinessAreaOther')">
                                                </div>
                                                <!-- [./ End] Other bussiness area -->

                                                <!-- Area list error -->
                                                <div class="invalid-feedback" style="display: block;" v-if="!OtherBusinessAreas && ErrorKey.BusinessAreas != undefined && ErrorKey.BusinessAreas.message != undefined">
                                                    <span class="error">{{ ErrorKey.BusinessAreas.message }}</span>
                                                </div>

                                                <!-- Other area error -->
                                                <div class="invalid-feedback" style="display: block;" v-if="OtherBusinessAreas && ErrorKey.BusinessAreaOther != undefined && ErrorKey.BusinessAreaOther.message != undefined">
                                                    <span class="error">{{ ErrorKey.BusinessAreaOther.message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- [./ End] BusinessAreas information -->

                                <!-- NumberOfEmployees information -->
                                <div title="Number of employees"  v-show="ActiveTabs == 'NumberOfEmployees'">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group geo_font">
                                                <label for="NumberOfEmployees">{{ Lang('Number of employees') }}</label>
                                                <input v-model="FormData.NumberOfEmployees" type="text" id="NumberOfEmployees" v-bind:placeholder="Lang('Approximate number') + '...'" class="form-control main-input geo_font" v-bind:class="ErrorKey['NumberOfEmployees'] != undefined ? ErrorKey['NumberOfEmployees'].class : ''" v-on:keyup="ValidateInput('NumberOfEmployees')">
                                                <div class="invalid-feedback" v-if="ErrorKey.NumberOfEmployees != undefined && ErrorKey.NumberOfEmployees.message != undefined">
                                                    <span class="error">{{ ErrorKey.NumberOfEmployees.message }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group geo_font">                                        
                                                <div class="custom-control custom-checkbox">
                                                    <input v-model="FormData.TermsAgreement" type="checkbox" v-bind:true-value="1" v-bind:false-value="null" class="custom-control-input" id="TermsAgreement" v-on:change="ValidateInput('TermsAgreement')">
                                                    <label class="custom-control-label geo_font" for="TermsAgreement">{{ Lang('Terms Agreement') }} <a data-toggle="modal" data-target="#TermsConditions" href="javascript:void()">{{ Lang('ReadAndAgreeTerms') }}</a></label>
                                                </div>
                                                <div class="invalid-feedback" style="display: block;" v-if="ErrorKey.TermsAgreement != undefined && ErrorKey.TermsAgreement.message != undefined">
                                                    <span class="error">{{ ErrorKey.TermsAgreement.message }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- [./ End] NumberOfEmployees information -->

                                <!-- Action buttons -->
                                <button type="button" class="geo_font agency_banner_btn cus_mb-10" v-if="ActiveTabs != 'PersonalInformation'" v-on:click="Back"><!-- <i class="fas fa-angle-left"></i> --> {{ Lang('Back') }}</button>
                                <button type="button" class="geo_font btn_hover agency_banner_btn cus_mb-10 float-right" v-if="ActiveTabs != 'NumberOfEmployees'" v-on:click="Next">{{ Lang('Next') }} <!-- <i class="fas fa-angle-right"> --></i></button>
                                <button type="button" class="geo_font btn_hover agency_banner_btn cus_mb-10 float-right" v-if="ActiveTabs == 'NumberOfEmployees'" v-on:click="Finish">{{ Lang('Register') }} <!-- <i class="fas fa-check"></i> --></button>
                                <!-- [./ End] Action buttons -->
                            </div>
                            <!-- [./ End] Form content -->
                            <div class="col-md-4"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" data-dismiss="modal" ref="CloseRegisterModal" style="display: none;"></button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->

        <!-- Modal Temrs conditions -->
        <div class="modal fade full-modal" id="TermsConditions" tabindex="-1" role="dialog" aria-labelledby="TermsConditions" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <!-- <h5 class="modal-title geo_font" id="exampleModalLongTitle">{{ Lang('Register') }}</h5> -->
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fas fa-times" style="font-size: 25px;"></i>
                        </button>
                    </div>
                    <div class="modal-body pb-4">
                        <div class="row">
                            <div class="col-md-3"></div>
                            <div class="col-md-6">                            
                                <h3>Service Terms and Conditions</h3>
                                <!-- Date: 05_ 05__ 2020 -->
                                <p>By and between: Wellness Corporation LLC - hereinafter: Provider and {{ FormData.CompanyName }}, {{ FormData.Country }}, {{ FormData.City }}, - hereinafter: User - {{ FormData.FirstName + ' ' + FormData.SurName }}</p>
                                
                                <h3>1. Definitions:</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>Platform – As provided: www.gymstinct.club accessible by Super-User account registered to the User.</span></li>
                                        <li><strong>b.</strong> <span>Platform Modules – Functionality and pages of the Platform including information and reports.</span></li>
                                        <li><strong>c.</strong> <span>Service – Functionality of the platform as indicated by this agreement.</span></li>
                                        <li><strong>d.</strong> <span>Provider – First Counterpart to this agreement, which is solely entitled and responsible for delivery and rendering of the services within the scope of this agreement;</span></li>
                                        <li><strong>e.</strong> <span>User – Second Counterpart to this agreement, which has rights and liabilities undertaken pursuant this agreement;</span></li>
                                        <li><strong>f.</strong> <span>Client – Potential third non-contractual party to this agreement, who is receiving final service benefits from Provider’s and User’s cumulative engagements within this agreement;</span></li>
                                        <li><strong>g.</strong> <span>Wallet – Personal balance account of a user company, where he is able to pay for platform fees by means of provided payment methods, from where provider will subtract amounts as indicated in article 4.a</span></li>
                                        <li><strong>h.</strong> <span>Wire transfer – A payment to provider bank/money account by means of offered payment methods</span></li>
                                        <li><strong>i.</strong> <span>Helpdesk – Support system, accessible over www.gymstinct.club user panel.</span></li>
                                        <li><strong>j.</strong> <span>Party – Individually referred each counterpart of this agreement;</span></li>
                                        <li><strong>k.</strong> <span>Parties – Collectively referred counterparts of this agreement.</span></li>
                                        <li><strong>l.</strong> <span>Super-User account – Granted by provider to the User that entitles him/her all the rights to use the Platform according to the chosen service plan.</span></li>
                                        <li><strong>m.</strong> <span>System-User – An employee of the User, that User has registered to his/her company account on the Platform and given him the access rights to different modules of the Platform.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>2. General Conditions</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>For the purposes of this agreement, the User asdasdasd by pushing the provided activation link, agrees that he/she has a sufficient authority under domestic and international laws to sign this agreement and act on behalf of the company as indicated in this agreement by using Super-User account granted to him/her by Provider.</span></li>
                                        <li><strong>b.</strong> <span>User is represented by and therefore liable to any terms and conditions (as indicated in this agreement) by a System-User accounts granted by him/her and his/her employees (System Users) to his/her employees and related parties.</span></li>
                                        <li><strong>c.</strong> <span>Provider is not liable for User’s activities/responsibilities towards the Client;</span></li>
                                        <li><strong>d.</strong> <span>User is liable for any client personal information obtained by it, stored and used within the platform under international and domestic law;</span></li>
                                        <li><strong>e.</strong> <span>User guarantees that any information of client, obtained during the ordinary business activities is accepted by client including process of such information by Provider;</span></li>
                                        <li><strong>f.</strong> <span>Provider is entitled to process information stored by user for data analysis purposes unless it contradicts client’s best interest and existing regulations;</span></li>
                                        <li><strong>g.</strong> <span>User is obliged to provide true and correct information about itself and its business activities, including and not limited to its business information.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>3. Subject of agreement</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>User agrees to use the platform provided by Provider for business process management under the condition declared in this agreement and pay service fees pursuant to this agreement, on the other hand, Provider agrees to deliver the Platform service within the terms of this agreement.</span></li>
                                    </ul>
                                </div>

                                <h3>4. Fees and service delivery terms</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>Prices for the platform service per club/month are indicated in USD as follows and may change under prior notice by Provider, if such occasion as indicated in the article 4.5 arises or by clients request for purpose of choosing a different plan:</span>
                                            <ul style="list-style: none;">
                                                <li><strong>i.</strong> <span>Free – basic functionality limited to a single system user, including modules:</span>
                                                    <ol>
                                                        <li>Club Operations</li>
                                                        <li>Basic Finance</li>
                                                        <li>Basic CRM</li>
                                                        <li>Warehouse</li>
                                                        <li>No support</li>
                                                    </ol>
                                                </li>
                                                <li><strong>ii.</strong> <span>89 USD Enterprise:</span>
                                                    <ol>
                                                        <li>Club Operations</li>
                                                        <li>Finance</li>
                                                        <li>HRM</li>
                                                        <li>CRM</li>
                                                        <li>Warehouse</li>
                                                        <li>Finance</li>
                                                        <li>Basic support over helpdesk</li>
                                                    </ol>
                                                </li>
                                                <li><strong>iii.</strong> <span>119 USD Network Enterprise (more than one club):</span>
                                                    <ol>
                                                        <li>Club Operations</li>
                                                        <li>Finance</li>
                                                        <li>HRM</li>
                                                        <li>CRM</li>
                                                        <li>Warehouse</li>
                                                        <li>Finance</li>
                                                        <li>Basic support over helpdesk</li>
                                                    </ol>
                                                </li>
                                            </ul>
                                        </li>
                                        <li><strong>b.</strong> <span>Provider is obliged to deliver the service according to the 4.a article no later than 24 hours after user has agreed and paid for the service in full.</span></li>
                                        <li><strong>c.</strong> <span>Service plan fees indicated in the article 4.a are for a calendar month, excluding any domestic taxes in user’s country of residence and business operations and payment charges by bank or transaction processing company. Total platform service will be accumulated on user virtual balance as defined in article 8.a</span></li>
                                        <li><strong>d.</strong> <span>Change platform, service and module fees, by notifying user at least one month earlier before such changes are implemented.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>5. Payment terms</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>All the service fee payments must be credited on to the user wallet in advance at least for the upcoming one-month period according to the service plan per article 4.1 chosen by the user</span></li>
                                        <li><strong>b.</strong> <span>Every payment by the user is made non-cash on the platform by business card or using Wire Transfer on the Provider bank account:></span>
                                            <div>
                                                <ul style="list-style: none;">
                                                    <li><strong>i.</strong> <span>If User choses to pay by Wire Transfer it should indicate the source account and bank details in the Users Wallet on the Platform in advance</span></li>
                                                    <li><strong>ii.</strong> <span>User should allow the reasonable time to Provider to check bank payments and apply credit to Users Wallet on the Platform</span></li>
                                                </ul>
                                            </div>
                                        </li>                                       
                                        <li><strong>c.</strong> <span>Any service fees related to the payment will be subtracted by Provider and credited net to the User Wallet</span></li>
                                    </ul>
                                </div>
                                
                                <h3>6. Rights and Duties</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>The Provider is obliged to:</span>
                                            <div>
                                                <ul style="list-style: none;">
                                                    <li><strong>i.</strong> <span>Deliver the service as per terms and conditions of this Agreement, without any potential material and legal defects.</span></li>
                                                    <li><strong>ii.</strong> <span>In the event of failure of the delivery within the specified terms (including poor quality, incomplete delivery) reimburse fees paid by User pro rata days.</span></strong>
                                                    <li><strong>iii.</strong> <span>Ensure at least 99% uptime of the Platform for 24/7 on the internet</span></li>
                                                    <li><strong>iv.</strong> <span>Provide necessary measures to secure Client and User information on the Platform</span></li>
                                                    <li><strong>v.</strong> <span>Provide support services as indicated in 4.a clause</span></li>
                                                    <li><strong>vi.</strong> <span>Notify User for any Platform updates, shortfalls and maintenance events and provide necessary information for User recommended actions</span></li>
                                                    <li><strong>vii.</strong> <span>Review User’s comments and questions and resolve problems quickly</span></li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li><strong>b.</strong> <span>The User is obliged to:</span>
                                            <div>
                                                <ul style="list-style: none;">
                                                    <li><strong>i.</strong> <span>Pay the total value of the service fees to the Supplier within the terms specified by this Agreement;</span></li>
                                                    <li><strong>ii.</strong> <span>Report any errors or inconsistencies in case of such findings without delay;</span></li>
                                                    <li><strong>iii.</strong> <span>Follow the guidelines and instructions as prescribed by Provider for the purposes of receiving the high-quality service;</span></li>
                                                    <li><strong>iv.</strong> <span>Ensure security of access to his/her Super-User and other System user accounts by taking necessary steps to store account access credentials on sufficiently secured OS platforms.</span></li>
                                                    <li><strong>v.</strong> <span>Not to transfer or give access to his Super-User and system-user accounts to any other third party not related to this agreement in any way. This does not account for employees of the User.</span></li>
                                                </ul>
                                            </div>
                                        </li>
                                        
                                        <li><strong>c.</strong> <span>Provider is entitled to:</span>
                                            <div>
                                                <ul style="list-style: none;">
                                                    <li><strong>i.</strong> <span>demand reimbursement of the value of the Agreement at the agreed time.</span></li>
                                                    <li><strong>ii.</strong> <span>Withhold service in case User fails to fulfill any of its obligations and restrict its employees’ access to the Platform by the period of maximum 3 month after Provider is aware of such a breach</span></li>
                                                    <li><strong>iii.</strong> <span>Delate information stored by the User on the Platform after the User fails to make remedies for the breaches within the period mentioned in article 6.c.ii</span></li>
                                                    <li><strong>iv.</strong> <span>Update platform design and functionality in his own best interests, in case it is not undermining best interests of the User.</span></li>
                                                    <li><strong>v.</strong> <span>Provide Users Clients with client portal services access including a web-page www.gymstinct.com mobile apps and any other means of digital access to it.</span></li>
                                                </ul>
                                            </div>
                                        </li>
                                        
                                        <li><strong>d.</strong> <span>User is entitled to request reimbursement for the services that was paid in full but Provider failed to deliver within the agreed time or quality</span></li>
                                        <li><strong>e.</strong> <span>The Parties undertake to fulfill their obligations under this Agreement in good faith.</span></li>
                                        <li><strong>f.</strong> <span>The termination of certain provisions of the Agreement does not relieve the parties from fulfilling other obligations.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>7. Force Majeure</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>In case any circumstances arise after signing this Agreement which prevents, fully or partially, fulfillment of the obligations under the present agreement by any of the parties, namely: flood, fire, war, embargo, blockade, natural disasters, export and import prohibition or other circumstances beyond the control of the parties, the time of fulfillment of the obligations shall be extended by corresponding period. The parties shall appraise each other of any such circumstances within 20 (twenty) calendar days from the commencement thereof.</span></li>
                                        <li><strong>b.</strong> <span>Both parties shall do their best to avoid or remove such circumstances and continue the fulfillment of their obligations as soon as such circumstances are removed. If such circumstances last more than 6 (six) months, either Party has the right to terminate the present agreement and, in this case, neither party has the right to claim a compensation of their losses from other party and any funds paid in advance shall be returned to the Buyer</span></li>
                                    </ul>
                                </div>
                                
                                <h3>8. Confidentiality</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>“Confidential Information” shall mean any and all information disclosed by one Party hereto (“Disclosing Party”) to the other Party (“Receiving Party”) pursuant to this Agreement which is described as (or provided under circumstances indicating it is) confidential or proprietary. Regardless of whether specifically identified as confidential or proprietary.</span></li>
                                        <li><strong>b.</strong> <span>Except to the extent expressly authorized by this Agreement or otherwise agreed in writing by the Parties, each Party agrees that it shall keep confidential and shall not publish or otherwise disclose and shall not use for any purpose other than as provided for in this Agreement any Confidential Information disclosed to it by the other Party pursuant to this Agreement.</span></li>
                                        <li><strong>c.</strong> <span>“Confidential Information” shall include any information provided by the Disclosing Party concerning the business, technology and information of Disclosing Party and any third party with which Disclosing Party deals, including, without limitation, business plans, technical data, solutions, product ideas, contracts, financial information, inventions, sales leads, strategic alliances, partners and client lists.</span></li>
                                        <li><strong>d.</strong> <span>“Confidential Information” shall not include any information that: (i) becomes publicly known through no wrongful act of Receiving Party or (ii) is required by law, regulation or order of any court or other government or regulatory agency to be disclosed, provided that Receiving Party shall notify Disclosing Party of such requirement so that Disclosing Party may seek an appropriate protective order.</span></li>
                                        <li><strong>e.</strong> <span>Parties shall comply with confidentiality requirement pursuant to this agreement within 5 years from the day this agreement is considered terminated.</span></li>
                                        <li><strong>f.</strong> <span>All Confidential Information shall remain the property of the Party disclosing the same (the ‘Disclosing Party’). Without the prior written consent of ‘Disclosing Party’, the Party receiving the same (being the ‘Receiving Party’) shall not disclose, nor shall it permit any others to disclose, to any third party or otherwise use, or permit any others to use, any Confidential Information other than for the Purpose. The Parties agree that any Confidential Information disclosed prior to the Effective Date shall be protected by the terms of this Agreement. The Receiving Party shall use no less than best efforts for care in protecting the Confidential Information.</span></li>
                                        <li><strong>g.</strong> <span>User is liable for any information loss or disclosure which may cause damage to the User, Provider or Client, which may also be a result of activities on Platform by User and its employees.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>9. Indemnification</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>The Provider shall be solely responsible for the design, development, supply, production and performance of its products (in case of existence) and the protection of its trade names and patents. User agrees to indemnify, hold the Provider harmless against and pay all losses, costs, damages or expenses, whatsoever, including counsel fees, which the Provider may sustain or incur on account of infringement or alleged infringements of patents, trademarks or trade names resulting from the sale of the Provider’s products, or arising on account of warranty claims, negligence claims, product liability claims or similar claims by third parties.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>10. Governing Law and Dispute Resolution.</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>This Agreement and any non-contractual obligations connected with it shall be governed by and construed in accordance with Georgian Law. Any dispute arising out of or in connection with this Agreement, including any question regarding its existence, validity or termination, which cannot be resolved through discussions between the Parties on an amicable basis within thirty (30) days from the date of the dispute, the dispute shall be referred to and finally resolved by Tbilisi City Court.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>11. Severability</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>If any provision(s) of this Agreement shall be held invalid, illegal, against public policy or otherwise unenforceable for any reason by a court of competent jurisdiction, against public policy or otherwise unenforceable, the validity of the remaining portions or provisions hereof shall not be affected. The remainder of the Agreement shall be valid and enforceable and the parties shall negotiate in good faith a substitute, valid and enforceable provision which most nearly effects the Parties’ intent in entering into this Agreement.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>12. Waiver</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>The Failure of either party at any time to enforce any rights or remedy available to it under this Agreement or otherwise with respect to any breach or failure by the other Party shall not be construed to be a waiver of such right or remedy with respect to any other breach or failure of the other Party.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>13. Termination</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>Should either party require this agreement to end, we agree to give written notice by e-mail or written letter communication.</span></li>
                                        <li><strong>b.</strong> <span>The agreement shall be considered terminated at the day of receiving the intent of termination by means of sub article “a” of article 10.</span></li>
                                        <li><strong>c.</strong> <span>If User does not use the Platform for consecutive one-year period Provider is entitled to terminate the agreement and suspend User account</span></li>
                                        <li><strong>d.</strong> <span>In case the agreement is terminated Provider has no obligation to keep any data related to the User and its Clients</span></li>
                                    </ul>
                                </div>
                                
                                <h3>14. European General Data Protection Regulation (GDPR)</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>The User has been informed by the Provider, that for them compliance with all applicable data protection laws is of the utmost importance; this also and particularly applies to the European General Data Protection Regulation of April 27, 2016 (Regulation (EU) 2016/679) (the GDPR). Against this background, the User undertakes to use best efforts that during the activities, milestones and measures in light of this agreement will continue to be pursued and accomplished by User and its data processing will be organized and operated in a manner, which is compliant with the requirements of the GDPR.</span></li>
                                    </ul>
                                </div>
                                
                                <h3>15. Miscellaneous</h3>
                                <div>
                                    <ul style="list-style: none;">
                                        <li><strong>a.</strong> <span>Neither the party shall transfer to a third party their right and obligations under this agreement without the written consent of the other party such consent not to be unreasonably withheld.</span></li>
                                        <li><strong>b.</strong> <span>Provider is entitled to make any amendments to this Agreement, which shall be subject of notification to User by written letter or E-mail communication means, if User does not agree with the changes made in the agreement, parties shall within 15-day period amicably resolve the issue. If the issue will not be resolved within the mentioned time-period, either party may terminate this agreement as mentioned in Sub article “a” of article 13 of the agreement.</span></li>
                                        <li><strong>c.</strong> <span>The agreement comes into full force after, User agrees the provided terms by indicating “Agreed terms and conditions” on the Platform</span></li>
                                        <li><strong>d.</strong> <span>This Agreement and the exhibits (including any reference and the part of the web: www.gymstinct.club) hereto represent and constitute the entire agreement between the parties, and supersedes and merges all prior negotiations, agreements and understandings, oral or written, with respect to any and all matters between the Provider and User.</span></li>
                                        <li><strong>e.</strong> <span>The agreement is presented in English and one additional preferred language as chosen by the User, in case of inconsistency between the two versions, the English version will prevail.</span></li>
                                        <li><strong>f.</strong> <span>The parties agree that accepting the terms and conditions of the agreement by User through electronical (reference to the www.gymstinct.club) means, shall be considered as a duly signature and delivery of manually executed counterpart of this Agreement to each parties.</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-3"></div>
                        </div>
                    </div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>
        <!-- [./ End] Modal Temrs conditions -->
    </div>
</template>
<script>
import Vue      from 'vue';
import Langs    from '@/mixins/Lang.js';
import Com      from '@/libs/Com.js';

// Loas sweet alert
import VueSweetalert2 from 'vue-sweetalert2';
import locale from "@/mixins/locale.js";
Vue.use(VueSweetalert2);

export default {
    name: 'HomePage',
    mixins:[ Langs, locale ],
    data : function () {
        return {
            ID          : 'Home',
            FormDataTmp : {
                FirstName   : null,
                SurName     : null,
                Email       : null,
                Password    : null,
                ConfPassword: null,
                Phone       : null,
                Country     : null,
                City        : null,
                PhoneIndex  : null,
                Phone       : null,
                CompanyName : null,
                RegistrationID      : null,
                BusinessAreas       : [],
                BusinessAreaOther   : null,
                NumberOfEmployees   : null,
                TermsAgreement      : null,
            },
            FormData    : {},
            ErrorMsg    : null,
            ErrorKey    : {},
            ValidObj    : {},
            ActiveTabs  : 'PersonalInformation',
            Rules       : {
                FirstName : {
                    Required    : true,
                    Message     : this.Lang('Validate').FirstName,
                    Min         : 2,
                    Max         : -1,
                },
                SurName : {
                    Required    : true,
                    Message     : this.Lang('Validate').SurName,
                    Min         : 2,
                    Max         : -1,
                },
                Email : {
                    Required    : true,
                    Message     : this.Lang('Validate').Email,
                    Regex       : /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
                },
                Password : {
                    Required    : true,
                    Message     : this.Lang('Validate').Password,
                    Min         : 6,
                    Regex       : /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{6,50}/,
                    // Regex       : /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{6,50}/,
                },
                ConfPassword : {
                    Required    : true,
                    Message     : this.Lang('Validate').ConfPassword,
                },
                Phone : {
                    Required    : true,
                    Message     : this.Lang('Validate').Phone,
                    Min         : 6,
                    Max         : 20,
                },
                PhoneIndex : {
                    Required    : true,
                    Message     : this.Lang('Validate').PhoneIndex,
                    Min         : 2,
                    Max         : 20,
                },
                Country : {
                    Required    : true,
                    Message     : this.Lang('Validate').Country,
                    Min         : 2,
                    Max         : 50,
                },
                City : {
                    Required    : true,
                    Message     : this.Lang('Validate').City,
                    Min         : 2,
                    Max         : 50,
                },
                CompanyName : {
                    Required    : true,
                    Message     : this.Lang('Validate').CompanyName,
                    Min         : 2,
                    Max         : 100,
                },
                RegistrationID : {
                    Required    : true,
                    Message     : this.Lang('Validate').RegistrationID,
                    Min         : 2,
                    Max         : 50,
                },
                BusinessAreas : {
                    Required    : true,
                    Message     : this.Lang('Validate').BusinessAreas,
                    Min         : 1,
                },
                BusinessAreaOther : {
                    Required    : true,
                    Message     : this.Lang('Validate').BusinessAreaOther,
                    Min         : 5,
                },
                NumberOfEmployees : {
                    Required    : true,
                    Message     : this.Lang('Validate').NumberOfEmployees,
                    Min         : 1,
                },
                TermsAgreement : {
                    Required    : true,
                    Message     : this.Lang('Validate').TermsAgreement,
                    Min         : 1,
                },
            },
            OtherBusinessAreas : false,
            ModalUpdate : 1,
            Stats       : null
        }
    },

    mounted : function () {
        setInterval(() => {
            if (document.querySelector('.modal.show') != null)
                document.getElementsByTagName('body')[0].className = 'modal-open';
        }, 300)

        // Load stats
        this.LoadStats();
    },

    watch : {},

    methods : {
        // Began preorder form render
        OpenPreOrder : function () {
            this.FormData   = JSON.parse(JSON.stringify(this.FormDataTmp))
            this.ErrorKey   = {};
            this.ModalUpdate = 1;

            if (this.$refs.CreatePreOrderForm != undefined)
                this.$refs.CreatePreOrderForm.click()

            this.GetCustomerLocation();
        }, // [./ End] CreatePreOrder()        

        GetCustomerLocation : async function () {
            var req = new XMLHttpRequest();
            var self = this;
            req.overrideMimeType("application/json");
            req.open('GET', 'https://ipapi.co/json/', true);
            req.onload  = function () {
                let Location = JSON.parse(req.responseText);
                Vue.set(self.FormData, 'Country', Location.country_name);
                Vue.set(self.FormData, 'City', Location.city);
                Vue.set(self.FormData, 'PhoneIndex', Location.country_calling_code);
                Vue.set(self.FormData, 'UserLocation', Location);
            };
            req.send(null);            
        }, // [./ End] GetCustomerLocation()

        Back : function () {
            this.ModalUpdate++;
            switch (this.ActiveTabs) {
                case 'Location' :
                    this.ActiveTabs = 'PersonalInformation';
                break;
                case 'BusinessInformation' :
                    this.ActiveTabs = 'Location';
                break;
                case 'BusinessAreas' :
                    this.ActiveTabs = 'BusinessInformation';
                break;
                case 'NumberOfEmployees' :
                    this.ActiveTabs = 'BusinessAreas';
                break;
                default :
            }
        }, // [./ End] Back()

        Next : function () {
            this.ModalUpdate++;
            switch (this.ActiveTabs) {
                case 'PersonalInformation' :
                    let ValidA = this.ValidUser();
                    if (ValidA)
                        this.ActiveTabs = 'Location';
                break;
                case 'Location' :
                    let ValidB = this.ValidCountry();
                    if (ValidB)
                        this.ActiveTabs = 'BusinessInformation';
                break;
                case 'BusinessInformation' :
                    let ValidC = this.ValidBusinessInformation();
                    if (ValidC)
                        this.ActiveTabs = 'BusinessAreas';
                break;
                case 'BusinessAreas' :
                    let ValidD = this.ValidBusinessAreas();
                    if (ValidD)
                        this.ActiveTabs = 'NumberOfEmployees';
                break;
                default :
            }
        }, // [./ End] Next()

        Finish : async function () {
            this.ModalUpdate++;
            let ValidE = this.NumberOfEmployees();
            if (! ValidE)
                return false;

            // Proccess to register
            let Response = await Com.Service(12, this.FormData);
            if (Response.StatusCode == 1) {
                // Close modal
                if (this.$refs.CloseRegisterModal != undefined)
                    this.$refs.CloseRegisterModal.click();
                // Success alert
                this.$swal({
                    title   : this.Lang('SuccessRegisterTitle'),
                    text    : this.Lang('SuccessRegisterText'),
                    icon    : 'success',
                    // timer   : 6000
                });
                // Resset FosrmData object
                this.FormData = {};
                // Wizard reset
                this.ActiveTabs = 'PersonalInformation';
                // Reset other bussiness area status
                this.OtherBusinessAreas = false;
            } else {
                this.$swal({
                    title   : this.Lang('ErrorRegisterTitle'),
                    text    : this.Lang('ErrorRegisterText') + '\n\n' + Response.Message,
                    icon    : 'error',
                    // timer   : 5000
                });
            }
        }, // [./ End] Finish()

        ValidUser : function () {
            this.ErrorKey['FirstName']  = {};
            this.ErrorKey['SurName']    = {};
            this.ErrorKey['Email']      = {};
            this.ErrorKey['Password']   = {};
            this.ErrorKey['ConfPassword']   = {};
            // Validate proccess
            this.ValidPart('FirstName');
            this.ValidPart('SurName');
            this.ValidPart('Email');
            this.ValidPart('Password');
            this.ValidPart('ConfPassword');
            // Check error
            let Err = Object.values(this.ErrorKey).filter(x => x.valid != undefined).length;
            if (Err > 0)
                return false;
            // Return true
            return true;
        }, // [./ End] ValidUser()

        ValidCountry : function () {
            this.ErrorKey['Country']    = {};
            this.ErrorKey['City']       = {};
            this.ErrorKey['Phone']      = {};
            this.ErrorKey['PhoneIndex'] = {};

            this.ValidPart('Country');
            this.ValidPart('City');
            this.ValidPart('PhoneIndex');
            this.ValidPart('Phone');

            // Check error
            let Err = Object.values(this.ErrorKey).filter(x => x.valid != undefined).length;
            if (Err > 0)
                return false;
            // Return true
            return true;
        }, // [./ End] ValidCountry()

        ValidBusinessInformation : function () {
            this.ErrorKey['CompanyName']    = {};
            this.ErrorKey['RegistrationID'] = {};

            this.ValidPart('CompanyName');
            this.ValidPart('RegistrationID');

            // Check error
            let Err = Object.values(this.ErrorKey).filter(x => x.valid != undefined).length;
            if (Err > 0)
                return false;
            // Return true
            return true;
        }, // [./ End] ValidBusinessInformation()

        ValidBusinessAreas : function () {
            // Otehr bussines arrea
            let Err = 1;
            if (this.OtherBusinessAreas) {
                this.ErrorKey['BusinessAreaOther'] = {}
                this.ValidPart('BusinessAreaOther');
                if (this.ErrorKey.BusinessAreaOther.valid == undefined)
                    Err = 0;
            } else {
                this.ErrorKey['BusinessAreas']    = {};
                this.ValidPart('BusinessAreas');
                if (this.ErrorKey.BusinessAreas.valid == undefined)
                    Err = 0;
            }

            // Check error
            if (Err > 0)
                return false;
            // Return true
            return true;
        }, // [./ End] ValidBusinessAreas()

        NumberOfEmployees : function () {
            this.ErrorKey['NumberOfEmployees']  = {};
            this.ErrorKey['TermsAgreement']     = {};

            this.ValidPart('NumberOfEmployees');
            this.ValidPart('TermsAgreement');

            // Check error
            let Err = Object.values(this.ErrorKey).filter(x => x.valid != undefined).length;
            if (Err > 0)
                return false;
            // Return true
            return true;
        },

        ValidateInput : function (Key) {
            switch (Key) {
                case 'FirstName' : 
                    this.ValidPart('FirstName');
                    break;
                case 'SurName' :
                    this.ValidPart('SurName');
                    break;
                case 'Email' :
                    this.ValidPart('Email');
                    break;
                case 'Password' :
                    this.ValidPart('Password');
                    break;
                case 'ConfPassword' :
                    this.ValidPart('ConfPassword');
                    break;
                case 'Country' :
                    this.ValidPart('Country');
                    break;
                case 'City' :
                    this.ValidPart('City');
                    break;
                case 'PhoneIndex' :
                    this.ValidPart('PhoneIndex');
                    break;
                case 'Phone' :
                    this.ValidPart('Phone');
                    break;
                case 'CompanyName' :
                    this.ValidPart('CompanyName');
                    break;
                case 'RegistrationID' :
                    this.ValidPart('RegistrationID');
                    break;
                case 'BusinessAreas' :
                    this.ValidPart('BusinessAreas');
                    break;
                case 'BusinessAreaOther' :
                    this.ValidPart('BusinessAreaOther');
                    break;
                case 'NumberOfEmployees' :
                    this.ValidPart('NumberOfEmployees');
                    break;
                case 'TermsAgreement' :
                    this.ValidPart('TermsAgreement');
                    break;
                default:
                    // Enter default code
            }
        }, // [./ End] ValidateInput()

        ValidPart : function (Key) {
            this.ModalUpdate++;
            switch (Key) {
                case 'FirstName' : 
                    this.ErrorKey['FirstName'] = {class   : 'is-valid'};
                    if (this.Rules.FirstName.Required == true && (this.FormData.FirstName == null || this.FormData.FirstName == '' || this.FormData.FirstName.length < this.Rules.FirstName.Min)) {
                        Vue.set(this.ErrorKey, 'FirstName', {
                            valid   : false,
                            class   : 'is-invalid',
                            message :this.Rules.FirstName.Message
                        });
                    }
                    break;
                case 'SurName' :
                    // SurName
                    this.ErrorKey['SurName'] = {class   : 'is-valid'};
                    if (this.Rules.SurName.Required == true && (this.FormData.SurName == null || this.FormData.SurName == '' || this.FormData.SurName.length < this.Rules.SurName.Min)) {
                        this.ErrorKey['SurName'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.SurName.Message
                        };
                    }
                    break;
                case 'Email' :
                    // Email
                    this.ErrorKey['Email'] = {class   : 'is-valid'};
                    if (this.Rules.Email.Required == true && (this.FormData.Email == null || this.FormData.Email == '' || ! this.Rules.Email.Regex.test(this.FormData.Email))) {
                        this.ErrorKey['Email'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.Email.Message
                        };
                    }
                    break;
                case 'Password' :
                    // Password
                    this.ErrorKey['Password'] = {class   : 'is-valid'};
                    if (this.Rules.Password.Required == true && (this.FormData.Password == null || this.FormData.Password == '' || ! this.Rules.Password.Regex.test(this.FormData.Password))) {
                        this.ErrorKey['Password'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.Password.Message
                        };
                    }
                    break;
                case 'ConfPassword' :
                    // Confirm password
                    this.ErrorKey['ConfPassword'] = {class   : 'is-valid'};
                    if (this.Rules.ConfPassword.Required == true && (this.FormData.ConfPassword == null  || this.FormData.ConfPassword == '' || this.FormData.Password.localeCompare(this.FormData.ConfPassword) != 0)) {
                        this.ErrorKey['ConfPassword'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.ConfPassword.Message
                        };
                    }
                    break;
                case 'Country' :
                    // SurName
                    this.ErrorKey['Country'] = {class   : 'is-valid'};
                    if (this.Rules.Country.Required == true && (this.FormData.Country == null || this.FormData.Country == '' || this.FormData.Country.length < this.Rules.Country.Min)) {
                        this.ErrorKey['Country'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.Country.Message
                        };
                    }
                    break;
                case 'City' :
                    this.ErrorKey['City'] = {class   : 'is-valid'};
                    if (this.Rules.City.Required == true && (this.FormData.City == null || this.FormData.City == '' || this.FormData.City.length < this.Rules.City.Min)) {
                        this.ErrorKey['City'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.City.Message
                        };
                    }
                    break;
                case 'PhoneIndex' :
                    this.ErrorKey['PhoneIndex'] = {class   : 'is-valid'};
                    if (this.Rules.PhoneIndex.Required == true && (this.FormData.PhoneIndex == null || this.FormData.PhoneIndex == '' || this.FormData.PhoneIndex.length < this.Rules.PhoneIndex.Min)) {
                        this.ErrorKey['PhoneIndex'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.PhoneIndex.Message
                        };
                    }
                    break;
                case 'Phone' :
                    if (this.Rules.Phone.Required == true && (this.FormData.Phone == null || this.FormData.Phone == '' || this.FormData.Phone.length < this.Rules.Phone.Min)) {
                        this.ErrorKey['Phone'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.Phone.Message
                        };
                    } else {
                        this.ErrorKey['Phone'] = {
                            class   : 'is-valid'
                        };
                    }
                    break;
                case 'CompanyName' :
                    if (this.Rules.CompanyName.Required == true && (this.FormData.CompanyName == null || this.FormData.CompanyName == '' || this.FormData.CompanyName.length < this.Rules.CompanyName.Min)) {
                        this.ErrorKey['CompanyName'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.CompanyName.Message
                        };
                    } else {
                        this.ErrorKey['CompanyName'] = {
                            class   : 'is-valid'
                        };
                    }
                    break;
                case 'RegistrationID' :
                    if (this.Rules.RegistrationID.Required == true && (this.FormData.RegistrationID == null || this.FormData.RegistrationID == '' || this.FormData.RegistrationID.length < this.Rules.RegistrationID.Min)) {
                        this.ErrorKey['RegistrationID'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.RegistrationID.Message
                        };
                    } else {
                        this.ErrorKey['RegistrationID'] = {
                            class   : 'is-valid'
                        };
                    }
                    break;
                case 'BusinessAreas' :
                    this.ErrorKey['BusinessAreas'] = {class   : 'is-valid'};
                    if (this.Rules.BusinessAreas.Required == true && (this.FormData.BusinessAreas.length < this.Rules.BusinessAreas.Min)) {
                        this.ErrorKey['BusinessAreas'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.BusinessAreas.Message
                        };
                    }
                    break;
                case 'BusinessAreaOther' :
                    this.ErrorKey['BusinessAreaOther'] = {class   : 'is-valid'};
                    if (this.Rules.BusinessAreaOther.Required == true && (this.FormData.BusinessAreaOther == '' || 
                                                                          this.FormData.BusinessAreaOther == null || 
                                                                          this.FormData.BusinessAreaOther.length < this.Rules.BusinessAreaOther.Min)) {
                        this.ErrorKey['BusinessAreaOther'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.BusinessAreaOther.Message
                        }
                    }
                    break;
                case 'NumberOfEmployees' :
                    if (this.Rules.NumberOfEmployees.Required == true && (this.FormData.NumberOfEmployees == null || this.FormData.NumberOfEmployees == '' || parseInt(this.FormData.NumberOfEmployees) < this.Rules.NumberOfEmployees.Min)) {
                        this.ErrorKey['NumberOfEmployees'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.NumberOfEmployees.Message
                        };
                    } else {
                        this.ErrorKey['NumberOfEmployees'] = {
                            class   : 'is-valid'
                        };
                    }
                    break;
                case 'TermsAgreement' :
                    if (this.Rules.TermsAgreement.Required == true && (this.FormData.TermsAgreement == null || this.FormData.TermsAgreement != 1)) {
                        this.ErrorKey['TermsAgreement'] = {
                            valid   : false,
                            class   : 'is-invalid',
                            message : this.Rules.TermsAgreement.Message
                        };
                    } else {
                        this.ErrorKey['TermsAgreement'] = {
                            class   : 'is-valid'
                        };
                    }
                    break;
                default:
                    // Enter default code
            }
        }, // [./ End] ValidPart()
        
        // Load statistics
        LoadStats : async function () {
            let Result = await Com.Service(281);
            if (Result.StatusCode == 1)
                Vue.set(this, 'Stats', Result.Data)
        }, // [./ End] LoadStats()
        
        // Number formatter 999, 1000 = 1k, 1000000 = 1m
        NumFormatter : function (num) {
            return Math.abs(num) > 999 ? (Math.abs(num) >= 1000000) ? Math.sign(num)*((Math.abs(num)/1000000).toFixed(1)) + 'M' : Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'K' : Math.sign(num)*Math.abs(num)
        }, // NumFormatter()
    }
}
</script>
<style type="text/css">
    .wizard-nav {display: none!important;}
    .wizard-progress-with-circle {display: none!important;}
</style>


// WEBPACK FOOTER //
// src/components/Home/index.vue